<div class="grid grid-rows-[auto,1fr,auto] bg-hero-radial text-white">
  @if (showBanner) {
    <div
      class="banner-base w-full bg-top-banner px-5 py-8 text-white md:px-8"
      animate.enter="banner-enter"
      animate.leave="banner-leave-up"
    >
      <div class="my-4 font-montserrat text-2xl md:text-4xl md:leading-[44px]">
        MyNitel is now MyPortal
      </div>
      <p
        class="font-lato text-sm font-normal leading-6 tracking-[0.5px] md:text-base"
      >
        Now that Nitel is part of Comcast Business, MyNitel will transition to
        MyPortal located at
        <a
          href="https://myportal.business.comcast.com"
          title="Go to MyPortal"
          class="comcast-white-link !font-bold"
        >
          https://myportal.business.comcast.com</a
        >.
      </p>
      <a
        href="https://www.nitelusa.com/blog/comcast-business-closes-nitel-acquisition/"
        target="_blank"
        title="Learn more about the acquisition"
        class="tertiary-button"
      >
        LEARN MORE
      </a>
    </div>
  }

  <!-- Header logo -->
  <header class="border-b-4 border-white bg-[#000A73]">
    <div class="px-5 py-5 md:px-8">
      <a
        href="https://business.comcast.com/"
        class="inline-block"
        target="_blank"
      >
        <img
          src="/assets/images/logos/comcast_business_logo.svg"
          alt="Comcast Business Logo"
          class="h-8 w-auto"
        />
      </a>
    </div>
  </header>

  <main
    class="grid min-h-[calc(100vh-350px)] place-items-center px-5 py-8 md:px-8 lg:min-h-[calc(100vh-260px)] lg:py-0"
  >
    <router-outlet></router-outlet>
  </main>

  <!-- Footer -->
  <app-footer [isPublic]="true"></app-footer>
</div>
